import { render, staticRenderFns } from "./OnSiteMessageGroupList.vue?vue&type=template&id=8704927e&scoped=true&"
import script from "./OnSiteMessageGroupList.vue?vue&type=script&lang=js&"
export * from "./OnSiteMessageGroupList.vue?vue&type=script&lang=js&"
import style0 from "./OnSiteMessageGroupList.vue?vue&type=style&index=0&id=8704927e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8704927e",
  null
  
)

export default component.exports